"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValueWhenTransacted = void 0;
var _definitions = require("@ppay/definitions");
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ticker = require("../../ticker");
var _constants = require("../../../constants");
var _ui = require("../../ui");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var TertiaryShadeText = (0, _styledComponents.default)(_ui.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-left: 3px !important;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.tertiaryShade;
});
var ValueWhenTransacted = function ValueWhenTransacted(_ref2) {
  var price = _ref2.price,
    ticker = _ref2.ticker,
    _ref2$convertedTicker = _ref2.convertedTicker,
    convertedTicker = _ref2$convertedTicker === void 0 ? _definitions.Ticker.USD : _ref2$convertedTicker;
  var convertedAmount = [/*#__PURE__*/_react.default.createElement(_ticker.TickerSymbol, {
    ticker: convertedTicker
  }), /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: price,
    ticker: convertedTicker
  })];
  if (_constants.AmountTickerPosition[ticker] !== 'left') {
    convertedAmount = convertedAmount.reverse();
    convertedAmount.splice(1, 0, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, " "));
  }
  return /*#__PURE__*/_react.default.createElement(_ui.P, {
    className: "d-inline-flex flex-wrap justify-content-end justify-content-md-start"
  }, /*#__PURE__*/_react.default.createElement(_ticker.TickerNumberFormat, {
    value: 1,
    ticker: ticker
  }), " ", ticker, /*#__PURE__*/_react.default.createElement(TertiaryShadeText, null, ' ≈ ', convertedAmount));
};
exports.ValueWhenTransacted = ValueWhenTransacted;